module.exports = __webpack_public_path__ + "img/bankTransfer4.3f58f1b1.png";